import { AboutPage } from 'modules/about';
import AnalyticsPage from 'modules/analytics/ui/pages/analytics-page';
import FeatureRoute from 'modules/navigation/ui/components/feature-route';
import AuthPagesSelectTournament from 'modules/auth/ui/pages/select-tournament/select-tournament';
import AuthPagesSignIn from 'modules/auth/ui/pages/sign-in';
import AuthPagesSignUp from 'modules/auth/ui/pages/sign-up';
import TourneyClient from 'modules/client/tournaments/ui/pages/tourney-client';
import DevicesPage from 'modules/devices/ui/pages/devices-page/devices-page';
import MainPage from 'modules/main/ui/pages/main-page/main-page';
import TemplateRenderPage from 'modules/manager/ui/pages/template-render-page';
import MediaManagerTemplatesListPage from 'modules/manager/ui/pages/media-manager-templates-list-page';
import MediaManagerEditorPage from 'modules/manager/ui/pages/media-manager-editor-page';
import { MigrationPage } from 'modules/migration';
import NotificationsPage from 'modules/notifications/ui/pages';
import CreateNotificationPage from 'modules/notifications/ui/pages/create';
import EditNotificationPage from 'modules/notifications/ui/pages/edit';
import OrganizerCreatePage from 'modules/organizer/ui/pages/orginizer-create-page';
import OrganizersList from 'modules/organizers/ui/pages/organizers-list';
import OverlayV2 from 'modules/overlay-v2/ui/page/overlayV2';
import { UsersPagesCacheProvider } from 'modules/roles-manager/ui/hooks/use-roles-manager-provider';
import RolesManagerPage from 'modules/roles-manager/ui/pages/roles-manager/roles-manager-page';
import ComponentPage from 'modules/tests/ui/pages/component/component-page';
import ComponentsPage from 'modules/tests/ui/pages/components/components-page';
import PlayersTestPage from 'modules/tests/ui/pages/players';
import FabricEditorDemoPage from 'modules/fabric-editor/ui/pages/fabric-editor-demo-page';
import TourneyPagesCreatePage from 'modules/tournaments/ui/pages/create';
import TourneyPagesEditPage from 'modules/tournaments/ui/pages/edit';
import TournamentsListPage from 'modules/tournaments/ui/pages/tournaments-list-page';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UDMainLayout from 'ud-ui/layout/main';
import { MainLayoutProvider } from 'ud-ui/layout/main/context';
import { QueryParamProvider } from 'use-query-params';

import ApplicationLinkPage from '../application-link/ui/pages/application-link-page';
import ApplicationSuccessPage from '../application-link/ui/pages/application-success-page';
import BoardPage from '../board-master/ui/pages/board/board-page';
import MasterBoardPage from '../board-master/ui/pages/main/master-board-page';
import PanelPage from '../board-master/ui/pages/panel/panel-page';
import LocationCreatePage from '../locations/ui/pages/location-create-page';
import LocationViewPage from '../locations/ui/pages/location-view-page';
import LocationsListPage from '../locations/ui/pages/locations-list-pages';
import OrganizerCard from '../organizers/ui/pages/ogranizer-card';
import PlayerCreatePage from '../players/ui/pages/player-create-page';
import PlayerViewPage from '../players/ui/pages/player-view-page';
import PlayerListPage from '../players/ui/pages/players-list-page';
import Calendar from '../schedule/ui/pages/calendar';
import PreviewTemplate from '../schedule/ui/pages/template-preview';
import SettingsPage from '../settings/ui/pages/settings-page/settings-page';
import FullSizeControlPanel from '../stream/ui/page/full-size-control-panel';
import Overlay from '../stream/ui/page/overlay';
import TeamsEditPage from '../teams/ui/pages/team-edit-page';
import TeamsCreatePage from '../teams/ui/pages/teams-create-page';
import TeamsPage from '../teams/ui/pages/teams-page';
import BoardEditor from '../template-editor/ui/pages/board-editor';
import BoardPreview from '../template-editor/ui/pages/board-preview';
import Boards from '../template-editor/ui/pages/boards';
import Catalog from '../template-editor/ui/pages/catalog';
import CatalogCard from '../template-editor/ui/pages/catalog-card';
import Templates from '../template-editor/ui/pages/templates';
import { Pages } from './domain/enums/pages';
import MobileGuard from './ui/components/mobile-guard';
import SecureRoute from './ui/components/secure-route';
import RouteAdapter from './utils/route-adapter';

const AppRouter = () => {
  return (
    <QueryParamProvider ReactRouterRoute={RouteAdapter}>
      <Routes>
        <Route
          path="/"
          element={
            <MobileGuard>
              <MainLayoutProvider>
                <UDMainLayout />
              </MainLayoutProvider>
            </MobileGuard>
          }
        >
          <Route
            path={Pages.INDEX}
            element={
              <SecureRoute>
                <MobileGuard>
                  <MainPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.SETTINGS.INDEX}/*`}
            element={
              <SecureRoute tournamentRequired={false}>
                <MobileGuard>
                  <SettingsPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.TOURNEYS.INDEX}
            element={
              <SecureRoute>
                <MobileGuard>
                  <TournamentsListPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.TOURNEYS.CREATE}`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <TourneyPagesCreatePage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.TOURNEYS.EDIT}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <TourneyPagesEditPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.TEAMS.INDEX}
            element={
              <SecureRoute>
                <MobileGuard>
                  <TeamsPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.TEAMS.CREATE}
            element={
              <SecureRoute>
                <MobileGuard>
                  <TeamsCreatePage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.TEAMS.EDIT}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <TeamsEditPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.TEMPLATE.INDEX}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <Templates />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.TEMPLATE.BOARDS}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <Boards />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.TEMPLATE.CATALOG.INDEX}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <Catalog />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.TEMPLATE.CATALOG.CARD}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <CatalogCard />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.ORGANIZERS.INDEX}`}
            element={
              <SecureRoute tournamentRequired={false} adminOnly>
                <MobileGuard>
                  <OrganizersList />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.ORGANIZERS.VIEW}`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <OrganizerCard />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.SCHEDULE.INDEX}`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <Calendar />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.SCHEDULE.VIEW}`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <PreviewTemplate />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.PLAYERS.INDEX}
            element={
              <SecureRoute>
                <MobileGuard>
                  <PlayerListPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.PLAYERS.VIEW}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <PlayerViewPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.PLAYERS.CREATE}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <PlayerCreatePage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.LOCATIONS.INDEX}
            element={
              <SecureRoute>
                <MobileGuard>
                  <LocationsListPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.LOCATIONS.CREATE}
            element={
              <SecureRoute>
                <MobileGuard>
                  <LocationCreatePage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={`${Pages.LOCATIONS.VIEW}/*`}
            element={
              <SecureRoute>
                <MobileGuard>
                  <LocationViewPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.ORGANIZER.CREATE}
            element={
              <SecureRoute>
                <MobileGuard>
                  <OrganizerCreatePage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.NOTIFICATIONS.INDEX}
            element={
              <SecureRoute>
                <MobileGuard>
                  <NotificationsPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.NOTIFICATIONS.CREATE}
            element={
              <SecureRoute adminOnly>
                <MobileGuard>
                  <CreateNotificationPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.NOTIFICATIONS.EDIT}
            element={
              <SecureRoute adminOnly>
                <MobileGuard>
                  <EditNotificationPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.ABOUT}
            element={
              <SecureRoute tournamentRequired={false}>
                <MobileGuard>
                  <AboutPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.MIGRATION.INDEX}
            element={
              <SecureRoute tournamentRequired={false} adminOnly>
                <MobileGuard>
                  <MigrationPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.TESTS.COMPONENTS}
            element={
              <SecureRoute tournamentRequired={false} adminOnly>
                <MobileGuard>
                  <ComponentsPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.TESTS.FABRIC_EDITOR_DEMO}
            element={
              <SecureRoute tournamentRequired={false} adminOnly>
                <MobileGuard>
                  <FabricEditorDemoPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.TESTS.COMPONENT}
            element={
              <SecureRoute tournamentRequired={false} adminOnly>
                <MobileGuard>
                  <ComponentPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.TESTS.PLAYERS}
            element={
              <SecureRoute tournamentRequired={false} adminOnly>
                <MobileGuard>
                  <PlayersTestPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.ROLES_MANAGER.INDEX}
            element={
              <SecureRoute tournamentRequired={true}>
                <MobileGuard>
                  <UsersPagesCacheProvider>
                    <RolesManagerPage />
                  </UsersPagesCacheProvider>
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.DEVICES.INDEX}
            element={
              <SecureRoute>
                <MobileGuard>
                  <DevicesPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.MEDIA_MANAGER.INDEX}
            element={
              <SecureRoute>
                <MobileGuard>
                  <MediaManagerTemplatesListPage />
                </MobileGuard>
              </SecureRoute>
            }
          />
          <Route
            path={Pages.ANALYTICS.INDEX}
            element={
              <SecureRoute>
                <FeatureRoute feature={'TOURNAMENT_ANALYTICS'}>
                  <MobileGuard>
                    <AnalyticsPage />
                  </MobileGuard>
                </FeatureRoute>
              </SecureRoute>
            }
          />
        </Route>

        <Route path={Pages.SIGN_UP} element={<AuthPagesSignUp />} />
        <Route path={Pages.SIGN_IN} element={<AuthPagesSignIn />} />
        <Route
          path={Pages.SELECT_TOURNAMENT}
          element={
            <MobileGuard>
              <AuthPagesSelectTournament />
            </MobileGuard>
          }
        />

        <Route
          path={`${Pages.TEMPLATE.EDITOR}/*`}
          element={
            <SecureRoute>
              <BoardEditor />
            </SecureRoute>
          }
        />
        <Route
          path={`${Pages.TEMPLATE.PREVIEW}/*`}
          element={
            <SecureRoute>
              <BoardPreview />
            </SecureRoute>
          }
        />
        <Route
          path={Pages.MEDIA_MANAGER.EDITOR}
          element={
            <SecureRoute>
              <MediaManagerEditorPage />
            </SecureRoute>
          }
        />
        <Route path={Pages.MEDIA_MANAGER.RENDER} element={<TemplateRenderPage />} />

        <Route path={`${Pages.OVERLAY.INDEX}/*`} element={<Overlay />} />
        <Route path={`${Pages.OVERLAY_V2.INDEX}/*`} element={<OverlayV2 />} />
        <Route path={`${Pages.OVERLAY.CONTROL_PANEL}/*`} element={<FullSizeControlPanel />} />

        <Route path={`${Pages.MASTER_BOARDS.INDEX}`} element={<MasterBoardPage />} />
        <Route path={`${Pages.MASTER_BOARDS.CONTROL_PANEL}`} element={<PanelPage />} />
        <Route path={`${Pages.MASTER_BOARDS.BOARD}`} element={<BoardPage />} />

        <Route path={Pages.APPLICATION_LINK.INDEX} element={<ApplicationLinkPage />} />
        <Route path={Pages.APPLICATION_LINK.SUCCESS} element={<ApplicationSuccessPage />} />

        <Route path={Pages.CLIENT_TOURNAMENT.VIEW_CHAMPIONSHIP} element={<TourneyClient />} />
      </Routes>
    </QueryParamProvider>
  );
};

// Memoize the AppRouter component to prevent unnecessary re-renders
export default React.memo(AppRouter);
